import { render, staticRenderFns } from "./ShelfItemWithImage.vue?vue&type=template&id=54d27892&scoped=true&"
import script from "./ShelfItemWithImage.vue?vue&type=script&lang=js&"
export * from "./ShelfItemWithImage.vue?vue&type=script&lang=js&"
import style0 from "./ShelfItemWithImage.vue?vue&type=style&index=0&id=54d27892&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d27892",
  null
  
)

export default component.exports